import React from "react"
import styled from "styled-components"

const ListStyled = styled.div`
  margin-left: 5px;
`

const List = ({content = ""}) => {
    return <ListStyled>{content}</ListStyled>
}

export default List
